import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/css/App.css';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import AuthLayout from 'layouts/auth';
import AdminLayout from 'layouts/admin';
import RtlLayout from 'layouts/rtl';
import { ChakraProvider } from '@chakra-ui/react';
import theme from 'theme/theme';
import { ThemeEditorProvider } from '@hypertheme-editor/chakra-ui';
import { AuthProvider } from './authProvider.js';

ReactDOM.render(
	<ChakraProvider theme={theme}>
	  <React.StrictMode>
		<HashRouter>
		  <AuthProvider>
			<ThemeEditorProvider>
			  <Switch>
				<Route path={`/admin`} component={AdminLayout} />
				<Route path={`/auth`} component={AuthLayout} />
				<Route path={`/rtl`} component={RtlLayout} />
				<Redirect from="/" to="/admin" />
			  </Switch>
			</ThemeEditorProvider>
		  </AuthProvider>
		</HashRouter>
	  </React.StrictMode>
	</ChakraProvider>,
	document.getElementById('root')
  );
